import { message } from 'antd';
import dayjs from 'dayjs';

export const FMT_DATE = 'DD.MM.YYYY';
export const FMT_TIME = 'HH:mm';
export const FMT_DATETIME = 'DD.MM.YYYY HH:mm';
export const FMT_DATE_API = 'YYYY-MM-DD';

export function showError(e) {
    const text = e?.userMessage ?? e?.message;
    message.error(typeof text === 'string' && text ? text : 'Ошибка');
}

export function toDayjs(value) {
    if (!value) return null;
    const d = dayjs(value);
    return d.isValid() ? d : null;
}

export function fmtDate(value) {
    const d = toDayjs(value);
    return d ? d.format(FMT_DATE) : '';
}

export function fmtTime(value) {
    const d = toDayjs(value);
    return d ? d.format(FMT_TIME) : '';
}

export function fmtDateTime(value) {
    const d = toDayjs(value);
    return d ? d.format(FMT_DATETIME) : '';
}

export function fmtMoney(value) {
    const n = Number(value);
    if (!Number.isFinite(n)) return '';
    return n.toLocaleString('ru-RU', { minimumFractionDigits: 2 });
}

export function fmtDateApi(value) {
    const d = toDayjs(value);
    return d ? d.format(FMT_DATE_API) : '';
}

// Дата/время для API: локальное время без таймзоны (колонки timestamp без tz)
export function toApiDate(value) {
    const d = toDayjs(value);
    return d ? d.format('YYYY-MM-DDTHH:mm:ss') : null;
}

// localStorage JSON для запоминания фильтров
export function getStored(key, def = null) {
    try {
        const v = localStorage.getItem(key);
        return v == null ? def : JSON.parse(v);
    } catch {
        return def;
    }
}

export function setStored(key, value) {
    try {
        localStorage.setItem(key, JSON.stringify(value));
    } catch {
        // ignore
    }
}
